import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as BalanceActions from '../../../../../../core/balance/action';
import BalanceData from './BalanceData';

function BalanceCard() {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.users);
  const { loading } = useSelector((store) => store.balance);

  const createAccount = useCallback(() => {
    if (!user?.stripe_details) {
      dispatch(BalanceActions.createConnectAccount(user.id));
      return;
    }

    if (!user?.stripe_details.details_submitted) {
      dispatch(BalanceActions.generateConnectAccountLink(user.id));
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (!user?.id || !user?.stripe_details) return;
    dispatch(BalanceActions.getBalance(user.id));
  }, [dispatch, user, createAccount]);

  return (
    <Paper sx={{ borderRadius: '12px' }}>
      <Box py={2} px={4} textAlign="left">
        <Typography fontWeight="bold">Balance</Typography>
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <BalanceData createAccount={createAccount} />
        )}
      </Box>
    </Paper>
  );
}

export default BalanceCard;
